var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrueltyFree = function SvgCrueltyFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.75 38.75c5.523 0 8.75-4.477 8.75-10a9.832 9.832 0 0 0-.382-2.588 7.474 7.474 0 0 0 6.632-7.412c0-6.25-3.75-7.5-12.5-12.5S13.75 0 12.5 2.5s1.25 5 6.25 7.5l7.108 3.553a7.465 7.465 0 0 0-2.108 5.197c0 .043.012.083.013.127a9.837 9.837 0 0 0-1.263-.127H11.25a10 10 0 0 0 0 20h6.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.75 28.75c5 0 7.5 5 5 10m10 0h7.5m1.875-21.25a.624.624 0 0 1 .625.625m-1.25 0a.624.624 0 0 1 .625-.625m0 1.25a.624.624 0 0 1-.625-.625m1.25 0a.624.624 0 0 1-.625.625"
  })));
};
export default SvgCrueltyFree;